import { Legacyprofile as LegacyprofileData } from '@/payload-types'
import Image from 'next/image'
import SeeProfileBtn from '../button/seeProfileBtn'
import LegacyProfileDetails from '@/components/legacy-profile-profile-card/profileDetails'
interface IProps {
  profileData: (string | null) | LegacyprofileData
  profilePicture?: { pictureDivCSS?: string; pictureCSS?: string }
  profileFullName?: { fullNameDivCSS?: string; fullNameCSS?: string }
  moreDetails?: {
    ifShow?: boolean
    ifFlex?: boolean
    value: { label: string | null; value: string | null }[]
    showMore?: boolean
    detailsCSS?: string
  }
  profileDescription?: { ifShow?: boolean; descCSS?: string }
  seeProfileBtn?: { ifShow?: boolean; btnCSS?: string }
  showMoreDetails?: boolean
  informationCSS?: string
}

export const LegacyProfileCardComponent = ({
  profileData,
  profilePicture,
  profileFullName,
  moreDetails = {
    ifShow: false,
    ifFlex: false,
    value: [
      {
        label: null,
        value: null,
      },
    ],
  },
  profileDescription = { ifShow: false },
  seeProfileBtn = { ifShow: false },
  informationCSS,
}: IProps) => {
  if (typeof profileData === 'object') {
    let href = ''
    if (typeof profileData === 'object') {
      const isProfessor = profileData?.professions?.some(
        (profession) => profession?.profession === 'Professor',
      )
      href = isProfessor ? `/professor/${profileData?.slug}` : `/individual/${profileData?.slug}`
    }
    return (
      <>
        <div className={`relative ${profilePicture?.pictureDivCSS}`}>
          <Image
            className={`${profilePicture?.pictureCSS} object-cover`}
            src={`${profileData?.profileImage}`}
            alt={profileData?.fullName ? `${profileData.fullName} Profile Image` : 'Profile Image'}
            fill
          />
        </div>
        <div className={`flex-1 ${informationCSS}`}>
          <div className={profileFullName?.fullNameDivCSS}>
            <span className={profileFullName?.fullNameCSS}>{profileData?.fullName}</span>
          </div>
          {moreDetails.ifShow && (
            <div className={moreDetails.detailsCSS}>
              <LegacyProfileDetails
                ifFlex={moreDetails.ifFlex}
                arrayOfData={moreDetails.value}
                showMore={moreDetails.showMore}
              />
            </div>
          )}
          {profileDescription?.ifShow && (
            <div className={profileDescription?.descCSS}>{profileData?.description}</div>
          )}
          {seeProfileBtn?.ifShow && (
            <SeeProfileBtn profileData={profileData} buttonCSS={seeProfileBtn?.btnCSS} href={href} />
          )}
        </div>
      </>
    )
  }
}

export default LegacyProfileCardComponent
